angular.module('licensure.internal')
    .directive('internalTop', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/headers/top/top.html',
            controller: ['$scope', 'Permissions', 'Enterprise', 'EnterpriseLoginCriteria','$state', function ($scope, Permissions, Enterprise, EnterpriseLoginCriteria, $state) {
                $scope.examsModuleOn = false;
                $scope.inspectionsModuleOn = false;
                $scope.disablePasswordLogin = false;

                $scope.getPermission = function (state, variable) {
                    Permissions.view(state).then(function (access) {
                        $scope[variable] = access;
                    });
                }

                const nonAuthStates = ['internal', 'internal.login', 'internal.forgotPassword', 'internal.twoFactorAuthentication', 'internal.changePassword', 'internal.oidcLogin', 'internal.oidcCallback'];
                if ($state.current && !nonAuthStates.includes($state.current.name)) {
                    Enterprise.get().then(function (enterprise) {
                        if (enterprise != null) {
                            $scope.examsModuleOn = (enterprise.exams_module == null ? false : enterprise.exams_module);
                            $scope.inspectionsModuleOn = (enterprise.inspections_module == null ? false : enterprise.inspections_module);
                            $scope.educationModuleOn = (enterprise.education_module == null ? false : enterprise.education_module);
                            $scope.userVoiceEnabled = (enterprise.uservoice_enabled == null ? false : enterprise.uservoice_enabled);

                            var rw_api_key = (enterprise.report_writer_api_key === null ? "" : enterprise.report_writer_api_key);
                            var rw_url = (enterprise.report_writer_url === null ? "" : enterprise.report_writer_url);
                            var rw_active = enterprise.reportwriter_enabled;
                            $scope.enableRW = rw_active && (rw_api_key !== "" && rw_url !== "");
                            $scope.nextGenReportingUrl = enterprise.next_gen_reporting_url;
                        }
                    });
                } else {
                    Enterprise.getLess().then(function (enterprise) {
                        if (enterprise != null) {
                            $scope.examsModuleOn = (enterprise.exams_module == null ? false : enterprise.exams_module);
                            $scope.inspectionsModuleOn = (enterprise.inspections_module == null ? false : enterprise.inspections_module);
                            $scope.educationModuleOn = (enterprise.education_module == null ? false : enterprise.education_module);
                            $scope.userVoiceEnabled = false;

                            var rw_api_key = "";
                            var rw_url = "";
                            var rw_active = false;
                            $scope.enableRW = rw_active && (rw_api_key !== "" && rw_url !== "");
                        }
                    });
                }

                Enterprise.getUserVoiceLink().then(function (link) {
                    if (link != null) {
                        $scope.userVoiceLink = link;
                    }
                });

                EnterpriseLoginCriteria.getEnterpriseDisablePasswordLogin().then(function (loginCriteria) {
                    // false = disable, true = allow
                    $scope.disablePasswordLogin = (loginCriteria == null) ? false : loginCriteria;
                });
            }],
            replace: true,
            link: function (scope, elem, attrs, ctrl) {
            }
        };
    }])
    ;